export default __webpack_public_path__ + "static/media/plus-icon.2c6b1381.svg";